module.exports = __webpack_public_path__ + "media/images/default/lp_top_achieved_file2-49733b403d3a8a2096f64ff5c29fd810.svg";